var MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Requests = MDB.GDPR.Requests || {};

$.extend(MDB.GDPR.Requests, {
    bootDetail: function(){
        $('.btn-mark-for-deletion').on('click', function () {
            var container = $(this).closest('.supplier-record-selection-container');

            var model = {
                requestId: container.data('requestId'),
                supplierId: container.data('supplierId'),
                statusPerRecord: _.map(container.find('.supplier-request-mark-for-deletion'), function (e) {
                    return {
                        recordId: $(e).data('supplierRequestId'),
                        shouldDelete: e.checked
                    };
                })
            };
            
            $.ajax({
                url: container.data('url'),
                method: 'POST',
                data: model,
                success: function() {
                    MDB.alert(MDB.loadResourceString('GDPR_Requests_ViewRequest_MarkSuppliersForDeletion_Success'));
                },
                error: function() {
                    MDB.alert(MDB.loadResourceString('GDPR_Requests_ViewRequest_MarkSuppliersForDeletion_Generic_Error'));
                }
            });
        });
    }
});